module.exports = __webpack_public_path__ + "resource/img/china.png?9e54bac8e67d9dff21bb124978186a4e";


//////////////////
// WEBPACK FOOTER
// ./src/images/china.png
// module id = 645
// module chunks = 0 2